import { Crumbs } from "@/components/layout/Crumbs";

/**
 * The top of every directory page, the same way every time: where you are, what the page is
 * called, and one plain paragraph saying what it is for. Buttons go in `children`.
 */
export function PageIntro({ trail = [], pills = [], kicker, title, description, right, children, testid = "page-intro" }) {
    return (
        <section className="border-b border-zinc-200 bg-white" data-testid={testid}>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 sm:py-8">
                <Crumbs trail={trail} pills={pills} testid={`${testid}-crumbs`} />
                <div className="mt-4 flex flex-wrap items-start justify-between gap-x-8 gap-y-4">
                    <div className="max-w-3xl">
                        {kicker && <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500" data-testid={`${testid}-kicker`}>{kicker}</p>}
                        <h1 className="mt-2 font-display text-4xl font-black leading-[0.95] tracking-tight text-zinc-900 sm:text-5xl" data-testid={`${testid}-title`}>{title}</h1>
                        {description && <p className="mt-3 max-w-2xl text-base text-zinc-600 md:text-lg" data-testid={`${testid}-description`}>{description}</p>}
                        {children && <div className="mt-5 flex flex-wrap items-center gap-3" data-testid={`${testid}-actions`}>{children}</div>}
                    </div>
                    {right && <div className="w-full sm:w-auto" data-testid={`${testid}-right`}>{right}</div>}
                </div>
            </div>
        </section>
    );
}
